import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeliveryEntity } from '@shared/domain/orders/delivery.entity';
import { PaymentModel } from '@shared/domain/orders/payment.model';
import { CartItem } from 'retail/app/common/models/cart-item';
import { CartService } from 'retail/app/common/providers/cart.service';
import { CreateOrderModel } from 'retail/app/orders/models/create-order.model';
import { OrdersService } from 'retail/app/orders/providers/orders.service';
import { BaseComponent } from 'shared-ui/components/base-component';
import { VAT } from 'shared-ui/models/vat';

@Component({
  selector: 'retail-order-info',
  templateUrl: './order-info.component.html',
  styleUrls: ['./order-info.component.scss'],
})
export class OrderInfoComponent extends BaseComponent implements OnInit {
  readonly vat = VAT;
  cartItems: CartItem[] = [];
  cartTotal = 0;
  total = 0;
  delivery?: DeliveryEntity;
  payment?: PaymentModel;
  @Input() continueLabel = 'Continue';
  @Input() showButtons = true;
  @Input() order?: Partial<CreateOrderModel>;
  @Output() back = new EventEmitter();
  @Output() next = new EventEmitter();

  constructor(private ordersService: OrdersService) {
    super();
  }

  ngOnInit(): void {
    if (this.order) {
      this.update(this.order);
    } else {
      this.update(this.ordersService.loadOrder());
      this.subscribe(this.ordersService.orderUpdate, order => this.update(order));
    }
  }

  openProductDetail(item: CartItem) {
    window.open(`/p/product/${item.name}/${item.id}`);
  }

  private update(order?: Partial<CreateOrderModel>) {
    if (order) {
      this.cartItems = order.cart ?? [];
      this.cartTotal = CartService.getItemsPrice(order.cart ?? []);
      this.total = order.total ?? 0;
      this.delivery = order.delivery;
      this.payment = order.payment;
    }
  }
}
